import * as api from "../Api";

export const getRequisitions = () => async (dispatch) => {
  try {
    const { data } = await api.getRequisitions();
    dispatch({ type: "GET_REQUISITIONS", payload: data });
  } catch (error) {}
};
